import { isBuiltDesktopApp } from "./logout";

const PRODUCTION_API_URL = "https://api.ano.dev";
const explicitApiUrl = import.meta.env.VITE_API_URL as string | undefined;

export const API_URL = explicitApiUrl
  ? explicitApiUrl
  : isBuiltDesktopApp()
    ? PRODUCTION_API_URL
    : "http://localhost:3001";

export const IS_LOCAL_DEV =
  API_URL.startsWith("http://localhost") ||
  API_URL.startsWith("http://127.0.0.1");
